<template>
  <qc-container :title="title" show-divider show-return>
    <el-descriptions v-if="detail" :column="3" border>
      <el-descriptions-item label-class-name="w100"  label="门店名称">
        {{detail.storeName}}
      </el-descriptions-item>
      <el-descriptions-item label-class-name="w100"  label="门店logo">
        <image-show v-if="detail.logo" :images="[filePath+detail.logo]" :width="200" :height="100"></image-show>
      </el-descriptions-item>
      <el-descriptions-item label-class-name="w100"  label="门店编号">
        {{detail.shopCode}}
      </el-descriptions-item>
      <el-descriptions-item label-class-name="w100"  label="联系电话">
        {{detail.storePhone}}
      </el-descriptions-item>
      <el-descriptions-item v-if="detail.businessTime" label-class-name="w100"  label="营业时间">
        {{detail.businessTime}}
      </el-descriptions-item>
      <el-descriptions-item label-class-name="w100"  label="门店地址">
        {{detail.address}}
      </el-descriptions-item>
    </el-descriptions>
  </qc-container>
  <qc-container v-if="detail.status==0"  title="审核信息" class="mt20">
    <el-form class="mr20" ref="ruleForm" :model="auditRow" label-width="100px">
      <form-item-rule label="审核" prop="status">
        <el-radio-group v-model="auditRow.status">
          <el-radio :label="1">同意</el-radio>
          <el-radio :label="2">拒绝</el-radio>
        </el-radio-group>
      </form-item-rule>
      <form-item-rule label="意见" prop="refundMsg">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入审核意见"
          v-model="auditRow.errorMsg">
        </el-input>
      </form-item-rule>

      <div class="but-box">
        <el-button  @click="returnLast()">返回</el-button>
        <el-button type="primary" @click="doAudit()">确定</el-button>
      </div>
    </el-form>
  </qc-container>

  <qc-container v-else  title="审核信息" class="mt20">
    <el-descriptions v-if="detail" :column="2" border>
      <el-descriptions-item label-class-name="w100"  label="审核">
        {{detail.status==1?"通过":"驳回"}}
      </el-descriptions-item>
      <el-descriptions-item label-class-name="w100"  label="意见">
        {{detail.errorMsg}}
      </el-descriptions-item>
    </el-descriptions>

    <return-box></return-box>
  </qc-container>
</template>

<script>
import QcContainer from "@/components/el/layout/qc-container.vue";
import ImageShow from "@/components/base/image-show.vue";
import FormItemRule from "@/components/el/form-item-rule.vue";
import ReturnBox from "@/components/home/return-box.vue";

export default {
  name: "shop-audit-detail",
  components: {ReturnBox, FormItemRule, ImageShow, QcContainer},
  data() {
    return {
      detail:{id:""},
      title:"加盟商信息",
      auditRow:{id:"",status:1,errorMsg:""}
    }
  },
  mixins: [tableBase],
  methods: {
    findDetail() {
      this.simpleGet("/api/mgr/store/shop/info/detail", {id: this.detail.id}, result => {
        this.detail = result.data;
      });
    },
    doAudit(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.auditRow.id = this.detail.id;
          this.simplePost("/api/mgr/store/shop/info/audit", this.auditRow, () => {
            this.findDetail();
          })
        }
      })
    }
  },
  mounted() {
    if(this.$route.query){
      if (this.$route.query.type) {
        this.title = this.$route.query.type === 0 ? "加盟商信息" : "实体店信息";
      }
      if (this.$route.query.id) {
        this.detail.id = this.$route.query.id;
        this.findDetail();
      }
    }

  }
}
</script>

<style scoped>
.but-box{
  text-align: right;
}
</style>
